import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// components
import { OpportunityRoutes } from '@amfam/opportunities';
import { InsuranceCardComponent } from '@amfam/overview/ui';

// feature modules
import { BillingRoutes, BillingRoutingGuards } from '../billing/billing-routing.module';
import { BusinessGuards, BusinessRoutes } from '../business/business-routing.module';
import { ClaimGuards, ClaimRoutes } from '../claim/claim-routing.module';
import { FeatureFlagGuard } from '../core';
import { AuthGuard } from '../core/auth/auth.guard';
import { PolicyGuards, PolicyRoutes } from '../policy/policy-routing.module';
import { ProfileRoutes } from '../profile/profile-routing.module';
import { ProgramRoutes } from '../program/program-routing.module';
import { NotFoundComponent } from '../shared/not-found/not-found.component';
import { SitemapComponent } from '../shared/sitemap/sitemap.component';
import { TermsRoutes, TermsRoutingGuards } from '../terms/terms-routing.module';
import { AccountComponent } from './account.component';
import { OverviewComponent } from './overview/overview.component';

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    data: {
      breadcrumb: 'Overview'
    },
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      { path: 'dashboard', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        component: OverviewComponent,
        data: {
          breadcrumb: false
        }
      },
      {
        path: 'insurance-card/:id',
        component: InsuranceCardComponent,
        data: {
          breadcrumb: 'Insurance Card'
        }
      },
      {
        path: 'ca-mileage/:policyNumber',
        canActivate: [FeatureFlagGuard],
        data: {
          breadcrumb: 'lazy_loaded_module',
          feature: 'california-mileage'
        },
        loadChildren: () => import('@amfam/policy/ca-mileage/feature').then(m => m.CaMileageRoutes)
      },
      {
        path: 'sitemap',
        component: SitemapComponent,
        data: { breadcrumb: 'Site Map' },
        canActivate: [AuthGuard]
      },
      {
        path: 'paperless',
        canActivate: [FeatureFlagGuard],
        loadChildren: () =>
          import('@amfam/profile/communication-preferences/feature').then(
            m => m.ProfileCommunicationPreferencesFeatureModule
          ),
        data: {
          breadcrumb: 'lazy_loaded_module',
          feature: 'auto_pay_phase_two',
          redirectRoute: '/overview'
        }
      },
      {
        path: 'faq',
        loadChildren: () => import('@amfam/shared/faq/feature').then(m => m.SharedFaqFeatureModule),
        data: {
          breadcrumb: 'lazy_loaded_module'
        }
      },
      ...BillingRoutes,
      ...PolicyRoutes,
      ...ProfileRoutes,
      ...ClaimRoutes,
      ...TermsRoutes,
      ...BusinessRoutes,
      ...ProgramRoutes,
      ...OpportunityRoutes,

      // 404 page
      {
        path: 'not-found',
        component: NotFoundComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [BillingRoutingGuards, BusinessGuards, ClaimGuards, PolicyGuards, TermsRoutingGuards]
})
export class AccountRoutingModule {}
